import { BifrostBackendNestApi } from "../gateways/BifrostBackendApi";
import axios from "axios";

export default {

	async getAccessTokenDataAzureAd({ url, queryString }) {
		return (await axios.post(url, queryString, {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded;charset=utf-8;"
			}
		})).data;
	},

	async authenticateAzureAd({strategy, tenantId, accessToken}) {
		return BifrostBackendNestApi.post(`/authentication/azure-ad`, {
			strategy,
			tenantId
		}, {
			headers: {
				Authorization: `Bearer ${accessToken}`
			}
		});
	},

	async authenticateAzureAdSelectedShop({ tenantId, shopNumber, externalAzureId, roles, userData }) {
		return BifrostBackendNestApi.post(
			`authentication/azure-ad/selectShop`, {
				shopNumber,
				tenantId,
				externalAzureId,
				roles,
				userData
			});
	},

	async authenticateGoogle({ queryData, tenantId, callbackUrl }) {
		return BifrostBackendNestApi.get(
			`authentication/google`, {
				params: {
					...queryData,
					tenantId,
					callbackUrl
				}
			});
	},

	async authenticateGoogleSelectedShop({ shopNumber, tenantId, externalGoogleId, externalGoogleEmail }) {
		return BifrostBackendNestApi.post(
			`authentication/google/selectShop`, {
				shopNumber: shopNumber,
				tenantId: tenantId,
				externalGoogleId: externalGoogleId,
				externalGoogleEmail: externalGoogleEmail
			});
	},

	async jwt1ToJwt2({ accessToken }) {
		return BifrostBackendNestApi.get(
			`authentication/jwt1ToJwt2`, {
				headers: {
					Authorization: `${accessToken}`
				}
			});
	}
};
